<template>
    <div id="app">
        <router-view/>
        <Loading></Loading>
        <!-- <audio autoplay loop id="audioObj">
            <source src="@/views/mp3/video.mp3" type="audio/mpeg">
            您的浏览器不支持 audio 元素。
        </audio> -->
    </div>
</template>

<script>

    import Loading from './components/loading/index'
    //import {getUserInfo} from '@/service/getData'

    export default {

        components: {
            Loading
        },
        methods: {
            //获取URL
            getUrlParam(name) {
                var url = window.location.href;
                url = url.substr(url.indexOf('?') + 1, url.length);
                var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
                var r = url.match(reg);
                if (r != null) {
                    return unescape(r[2]);
                }
                return null;
            }
        },
        beforeCreate(){

         
        },
        beforeMount: function () {

        },
        mounted: function () {
            
        }
    }
</script>


<style lang="scss">
    #nav {
        padding: 30px;
        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }

    #app {
        height: 100%;
        background:#fff;
        position: relative;
        z-index:9;
    }

    #audioObj{
        position: absolute;
        top:0px;
        left:0px;
        z-index: -1;
    }

</style>
